'use client';

import { useDynamicContext } from '@dynamic-labs/sdk-react-core';
import { useEffect } from 'react';

import { Loader, tw } from '@repo/ui';
import { useScreenSize } from '@repo/utils';

import { useIsClaimEnded } from '@claim/hooks/use-claim-ended';
import { useIsBrave } from '@claim/hooks/use-is-brave';
import { useIsPreClaimActive } from '@claim/hooks/use-pre-claim-active';

import { BaseLayout } from '../components/layouts/base-layout';
import { Claim } from '../components/views/claim';
import { LoggedOut } from '../components/views/logged-out';
import { Register } from '../components/views/register';
import { WarningModal } from '../components/warning-modal';
import { useIsClaimActive } from '../hooks/use-claim-active';

export default function Page() {
  const { user, sdkHasLoaded } = useDynamicContext();
  const { isBrave, detectBrave } = useIsBrave();
  const { isMobile } = useScreenSize();

  const isClaimActive = useIsClaimActive();
  const preClaimActive = useIsPreClaimActive();
  const isClaimEnded = useIsClaimEnded();

  useEffect(() => {
    detectBrave();
  }, []);

  const component = () => {
    if (sdkHasLoaded) {
      if (user && !preClaimActive && !isClaimEnded) {
        return isClaimActive ? <Claim /> : <Register />;
      } else {
        return <LoggedOut />;
      }
    } else {
      return (
        <div
          className={tw(
            'relative z-10 mx-auto min-h-screen w-full max-w-6xl',
            'flex items-center justify-center',
          )}
        >
          <Loader
            size='large'
            theme='secondary'
          />
        </div>
      );
    }
  };

  return (
    <BaseLayout>
      <div className='flex w-full justify-center'>
        <div className='flex w-full flex-col gap-2'>{component()}</div>
      </div>

      {isBrave || isMobile ? (
        <WarningModal type={isBrave ? 'brave' : 'mobile'} />
      ) : null}
    </BaseLayout>
  );
}
